<template>
  <section>
    <header>
      Кредитный лимит
    </header>

    <VForm ref="form">
      <VInputNumberRus
        v-model="localPartner.creditLimitAmount"
        label="Кредитный лимит"
        :min="0"
        :precision="3"
        :disabled="!$core.currentUser.isPrivileged"
      >
        <template #helper-text>
          Сумма в рублях
        </template>
      </VInputNumberRus>

      <VInputNumberRus
        v-model="localPartner.paymentDeferralDays"
        label="Отсрочка платежа"
        :min="0"
        :precision="0"
        :disabled="!$core.currentUser.isPrivileged"
      >
        <template #helper-text>
          Количество календарных дней
        </template>
      </VInputNumberRus>

      <VTextarea
        v-if="$core.currentUser.isPrivileged"
        label="Комментарий"
        v-model="localPartner.creditLimitComment"
        placeholder="Введите комментарий"
        :min-height="77"
      />

    </VForm>

    <div>
      <VButton
        theme="primary"
        :disabled="!$core.currentUser.isPrivileged"
        @click="save"
      >
        Сохранить
      </VButton>
    </div>
  </section>
</template>

<script lang="ts">
import Partner         from '@/domains/Partners/Partner';
import PartnersService from '@/domains/Partners/PartnersService';

import ValidationFormMixin from '@/mixins/validation-form-mixin';

export default defineComponent({
  name: 'CreditLimitSection',

  mixins: [ValidationFormMixin],

  props: {
    localPartner: {
      type: Object as PropType<Partner>,
      required: true,
    },
  },

  emits: ['partner:updated'],

  data() {
    return {
      PartnersService
    };
  },

  methods: {
    async save(): Promise<void> {
      await this.validate();

      if (!this.isValid) {
        this.scrollToError();
        return;
      }

      const success = await PartnersService.update(this.localPartner);

      if (!success) {
        return;
      }

      this.$emit('partner:updated');
    },
  },
});
</script>
